










































import {Vue, Component} from 'vue-property-decorator';
import {namespace} from "vuex-class";
import {IApiErrors} from "@/models/ApiModels";
import {ISendReset} from "@/models/loginModels";
import {sendResetSms} from "@/services/loginManager";
import {errorHandler} from "@/services/services";

import PhoneInput from "@/views/components/FormInputs/PhoneInput.vue";

const normalizePhoneInput = (el: string) => el.replace(/\s/g, '');

const userDataModule = namespace("userData");

@Component({
  name: 'SendResetPassword',
  components: {
    PhoneInput,
  },
})
export default class SendResetPassword extends Vue {
  @userDataModule.Action('sendResetPassword')
  private sendResetPassword !: (userData: ISendReset) => Promise<any>;

  private loading: boolean = false;
  private email: string = "";
  private internationalPhoneNumber: string = ""; // in here we have the phone with the code


  private errors: IApiErrors = {};

  get activeButton(): boolean {
    // return (this.email.length > 2);
    return this.internationalPhoneNumber !== "" && this.internationalPhoneNumber.length > 3;
  }

  private sendRecoverPasswordNotification() {
    if (this.activeButton) {

      this.clearErrors();
      this.loading = true;

      const sendResetBody: ISendReset = {
        // email: this.email,
        phone_number: normalizePhoneInput(this.internationalPhoneNumber),
      };

      sendResetSms(sendResetBody)
          .then(this.showSuccess)
          .catch(this.showSuccess) // we always will return the same message.
          .finally(() => this.loading = false);
    }
  }

  private showSuccess() {
    this.$uiBus.emit("genericMessage:show", this.$t('sendReset.success'));
  }

  private showErrors(err: any) {
    const errors = errorHandler.handleErrorsResponse(err, 'sendResetForm.errors');
    Vue.set(this, 'errors', errors);
  }

  private clearErrors() {
    Vue.set(this, 'errors', {});
  }

  private removeError(e: any) {
    Vue.set(this.errors, e, '');
  }
}
